import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Module-level shared store so multiple components share one fetch/poll cycle.
const store = { tiers: null, listeners: new Set(), timer: null, inflight: null };

async function fetchAvailability() {
  if (store.inflight) return store.inflight;
  store.inflight = axios
    .get(`${API}/memberships/availability`)
    .then((res) => {
      store.tiers = res.data.tiers;
      store.listeners.forEach((fn) => fn(store.tiers));
    })
    .catch((e) => {
      if (process.env.NODE_ENV !== "production") console.error("Availability fetch failed", e);
    })
    .finally(() => { store.inflight = null; });
  return store.inflight;
}

function startPolling(pollMs) {
  if (store.timer) return;
  const tick = async () => {
    await fetchAvailability();
    store.timer = store.listeners.size ? setTimeout(tick, pollMs) : null;
  };
  store.timer = setTimeout(tick, store.tiers ? pollMs : 0);
}

export function useAvailability(pollMs = 30000) {
  const [tiers, setTiers] = useState(store.tiers);

  useEffect(() => {
    store.listeners.add(setTiers);
    if (store.tiers) setTiers(store.tiers);
    startPolling(pollMs);
    return () => {
      store.listeners.delete(setTiers);
      if (!store.listeners.size && store.timer) {
        clearTimeout(store.timer);
        store.timer = null;
      }
    };
  }, [pollMs]);

  return tiers;
}
